import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import Report002Container from 'app/containers/Report/Report002'

const Report002PageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_002)}</PageTitle>
      <Report002Container />
    </>
  )
}
const Report002Page = memo(Report002PageCpn, isEqual)

export default Report002Page
